import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";

import Loading from "../../common/Loading";

import { PROJECT_PROGRESS_COLUMNS } from "./columns";

const ProjectProgressList = ({ data, loading }) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        data={data}
        columns={PROJECT_PROGRESS_COLUMNS}
        showPagination={false}
        pageSize={data.length}
      />
      {/* <pre>
        <code>{JSON.stringify(data, null, 2)}</code>
      </pre> */}
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
ProjectProgressList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};
export default ProjectProgressList;
